/* One model supports visual exploration and the app-confirmed reward reveal. */
if (!customElements.get('dope-dice-interactive')) {
  customElements.define('dope-dice-interactive', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.engine?.dispose();
      this.abort = new AbortController();
      this.engine = null;
      this.loading = null;
      this.unavailable = false;
      this.serial = (this.serial || 0) + 1;
      this.addEventListener('dope:dice-context-lost', () => {
        this.engine = null;
        this.loading = null;
        ++this.serial;
      }, {signal:this.abort.signal});
    }
    loadModule() { return import(this.dataset.rendererUrl); }
    async ready() {
      if (this.engine) return this.engine;
      if (this.unavailable) throw new Error('Interactive dice are unavailable');
      if (this.loading) return this.loading;
      const lifetime = this.abort;
      const pending = (async () => {
        const module = await this.loadModule();
        if (lifetime.signal.aborted) throw new DOMException('Disconnected','AbortError');
        const engine = await module.createDiceScene(this, {
          modelUrl:this.dataset.modelUrl, environmentUrl:this.dataset.environmentUrl, signal:lifetime.signal,
        });
        if (lifetime.signal.aborted) { engine.dispose(); throw new DOMException('Disconnected','AbortError'); }
        this.engine = engine;
        return engine;
      })();
      this.loading = pending;
      try { return await pending; }
      catch(error) {
        if(this.loading===pending)this.loading=null;
        if (!lifetime.signal.aborted && error.name !== 'AbortError') this.unavailable = true;
        throw error;
      }
    }
    async play(index, options) {
      const serial = ++this.serial, engine = await this.ready();
      if (serial !== this.serial || this.abort.signal.aborted) return false;
      engine.play(index,options);
      return true;
    }
    async preview() {
      if (document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return false;
      const serial = ++this.serial, engine = await this.ready();
      if (serial !== this.serial || this.abort.signal.aborted || document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return false;
      engine.snap(0);
      return true;
    }
    pause() { ++this.serial; this.engine?.pause(); }
    showResult(index) { ++this.serial; if(!this.engine)return false; this.engine.snap(index); return true; }
    disconnectedCallback() {
      this.pause();
      this.abort?.abort();
      this.engine?.dispose();
      this.engine = null;
      this.loading = null;
    }
  });
}
